import React, { useEffect, useState } from "react";
import './style.css';
import { Layout, Spin, Table, Button, Space, Select, Input, DatePicker, Row, Col, Dropdown, Menu, Popconfirm, Modal } from 'antd';
import {
  PlusOutlined, SearchOutlined, DownOutlined, SyncOutlined, MoreOutlined, DeleteOutlined
} from '@ant-design/icons';
import { Link, useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { getAllProcess, chdAllProcessSelector, clearState, addKiv, SearchAllProcess, DeleteProcessAsyn } from './ChdAllProcessSlice';
import ability from '../../../config/ability';
import { logout, authSelector } from '../../Auth/authSlice';
import Container from '../../Layout/Container';
import moment from 'moment';

const { Header, Content, Footer } = Layout;
const { Search } = Input;
const { Option } = Select;
const ntop = "none";
const nbottom = "bottomCenter";
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const { confirm } = Modal;

export default function AllProcess() {
  const location = useLocation();
  const dispatch = useDispatch();
  let history = useHistory();
  
  const [isLoading, setLoading] = useState(false);
  const { isFetching, isAllProcessSuccess, isError, errorMessage, AllProcessData, processCount } = useSelector(chdAllProcessSelector);
  const { user } = useSelector(authSelector);
  const loggedInUser = user.username;
  
  const [AllProcessInfo, setDataSource] = useState([]);
  const [page, setPage] = useState(1);
  const [storepage, setstorePage] = useState(1);
  const [pheader, setPheader] = useState("All Process");
  const [pagecount, setPagecount] = useState(0);
  const [search, setSearch] = useState('');
  const [selectedOption, setSelectedOption] = useState("Inbox & Sent");

  // Columns definition
  const renderContent = (value) => ({ children: value, props: {} });

  const columns = [
    { title: 'Ref. No.', dataIndex: 'refno', render: renderContent },
    { title: 'Process Subject', dataIndex: 'subject', render: renderContent },
    { title: 'Created On', dataIndex: 'created_on', render: renderContent },
    { title: 'Created By', dataIndex: 'created_by', render: renderContent },
    {
      title: 'KIV',
      dataIndex: 'kiv',
      render: (text, row) => ({
        children: <a onClick={(e) => showConfirm(row, e)}><button>KIV</button></a>
      })
    },
    {
      title: 'ACTION',
      dataIndex: 'action',
      render: (text, row) => ({
        children: <a onClick={(e) => handleProcessClick(row, e, storepage, search, selectedOption, pheader, pagecount)}>View Log</a>
      })
    },
    {
      title: '',
      dataIndex: '',
      key: 'x',
      fixed: "left",
      width: 100,
      render: (text, row) => ({
        children: <>
          {row.checkDel.length > 0 &&
            <Dropdown overlay={() => menu(row)} trigger={["click"]} placement="bottomRight" arrow>
              <a style={{ color: "#c5c7cd", fontSize: 25 }} onClick={(e) => e.preventDefault()}>
                <MoreOutlined />
              </a>
            </Dropdown>
          }
        </>
      })
    }
  ];

  const menu = (row) => (
    <Menu>
      <Menu.Item key="1">
        <Popconfirm
          title="Are you sure you want to delete this process?"
          onConfirm={(e) => DelCompletedconfirm(e, row)}
          okText="Yes"
          cancelText="No"
          icon={<DeleteOutlined style={{ color: 'red' }} />}
        >
          <DeleteOutlined /> &nbsp; Delete
        </Popconfirm>
      </Menu.Item>
    </Menu>
  );

  const showConfirm = (row) => {
    confirm({
      title: 'Store in KIV ?',
      onOk() {
        const storeKiv = {
          processId: row.action,
          username: loggedInUser,
          subject: row.subject,
          date: row.created_at,
          createdBy: row.created_by,
          refno: row.refno,
        };
        dispatch(addKiv(storeKiv));
      },
      onCancel() { console.log('Cancel'); },
    });
  };

  const DelCompletedconfirm = (e, row) => {
    e.preventDefault();
    dispatch(DeleteProcessAsyn(row.action));
    setTimeout(() => dispatch(getAllProcess(page)), 100);
  };

  const handleProcessClick = (row) => {
    setstorePage(page);
    history.push({
      pathname: '/view-process',
      state: {
        processName: row.action,
        mystorepage: storepage,
        mysearch: search,
        myOption: selectedOption,
        myheader: pheader,
        mycount: pagecount,
      }
    });
  };

  const fetchSearch = (x) => {
    const isEmpty = !x || x.trim() === '';
    setSearch(x);

    if (isEmpty) {
      setPage(1);
      setPheader('All Process');
      dispatch(getAllProcess(1)); // useEffect will handle updating dataSource
      return;
    }

    setPheader('All Process');
    let q = `search=${x}&page=1&limit=10`;
    dispatch(SearchAllProcess(q)).then(res => {
      if (res) {
        setDataSource(res.data.data);
        setPagecount(res.data.count);
        setPage(1);
      } else {
        setDataSource([]);
        setPagecount(0);
      }
    });
  };

  const fetchFolderInbox = () => {
    setPage(1);
    const q = `search=00000inbox${loggedInUser}&page=1&limit=10`;
    dispatch(SearchAllProcess(q)).then(res => {
      if (res) {
        setDataSource(res.data.data);
        setPagecount(res.data.count);
      } else {
        setDataSource([]);
        setPagecount(0);
      }
    });
  };

  const fetchFolderSent = () => {
    setPage(1);
    const q = `search=00000!nbox${loggedInUser}&page=1&limit=10`;
    dispatch(SearchAllProcess(q)).then(res => {
      if (res) {
        setDataSource(res.data.data);
        setPagecount(res.data.count);
      } else {
        setDataSource([]);
        setPagecount(0);
      }
    });
  };

  const fetchAllFolder = () => {
    setPage(1);
    dispatch(getAllProcess(1)); // useEffect will populate DataSource
    setPheader('All Process');
  };

  const myhandleChange = (value) => {
    setSelectedOption(value);
    value === 'inbox' ? fetchFolderInbox()
      : value === 'sent' ? fetchFolderSent()
      : fetchAllFolder();

    setSearch(value === 'sent' ? `00000!nbox${loggedInUser}` 
      : value === 'inbox' ? `00000inbox${loggedInUser}` 
      : '');
    
    setPheader(value === 'inbox' ? 'Inbox' : value === 'sent' ? 'Sent' : 'All Process');
  };

  const onDateChange = (value, dateString) => {
    if (dateString) {
      const mydate = moment(dateString).format('YYYY-MM-DD');
      const q = `search=${mydate}&page=1&limit=10`;
      dispatch(SearchAllProcess(q)).then(res => {
        if (res) {
          setDataSource(res.data.data);
          setPagecount(res.data.count);
          setPage(1);
        }
      });
    } else {
      setPage(1);
      dispatch(getAllProcess(1));
      setSelectedOption('Inbox & Sent');
      setSearch('');
      setPheader('All Process');
    }
  };

  const ChangeAllProcessPagination = (v) => {
    setPage(v.current);
    const q = `search=${search}&page=${v.current}&limit=10`;
    if (search) {
      dispatch(SearchAllProcess(q)).then(res => {
        if (res) setDataSource(res.data.data);
      });
    } else {
      dispatch(getAllProcess(v.current));
    }
  };

  useEffect(() => {
    setLoading(true);
    dispatch(clearState());
    dispatch(getAllProcess(1));
  }, []);

  useEffect(() => {
    if (isError) {
      setLoading(false);
      toast.error(errorMessage);
    }
    if (isAllProcessSuccess) {
      setLoading(false);
      setDataSource(AllProcessData.data);
      setPagecount(processCount);
    }
  }, [isError, isAllProcessSuccess, AllProcessData, processCount]);

  // Data formatting for Table
  const dataSource = isLoading ? [] : AllProcessInfo.map(row => ({
    id: row._id,
    refno: row.newrefno,
    subject: row.newsubject,
    kiv: row.processId,
    action: row.processId,
    created_on: moment(row.created_at).format("ll"),
    created_by: row.username.toUpperCase(),
    checkDel: '',
  }));

  return (
    <Container>
      <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
      <div className="site-layout-content" style={{ marginTop: 5 }}>
        <div style={{ padding: 24, paddingTop: 16 }}>
          <h2 style={{ paddingLeft: 16, paddingTop: 20, borderTop: '1px solid #dfe0eb', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', marginBottom: 0, backgroundColor: '#ffffff' }}>
            {pheader} ({pagecount ? pagecount : 0})
          </h2>

          <Space style={{ padding: 16, width: '100%', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', backgroundColor: '#ffffff' }} size="large">
            <Row style={{ width: '100%' }}>
              <Col span="10">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Input
                    placeholder="Search by doc. number or subject"
                    size="large"
                    value={search}
                    onChange={e => fetchSearch(e.target.value)}
                  />
                  <DatePicker onChange={onDateChange} style={{ marginLeft: '4px' }} size="large" format={'ll'} />
                </div>
              </Col>
              <Col span="14" style={{ textAlign: 'right' }}>
                <Space>
                  <Select style={{ width: 120 }} value={selectedOption} onChange={myhandleChange}>
                    <Option value="Inbox & Sent">Inbox & Sent</Option>
                    <Option value="inbox">Inbox</Option>
                    <Option value="sent">Sent</Option>
                  </Select>
                </Space>
              </Col>
            </Row>
          </Space>

          <Table
            columns={columns}
            onChange={ChangeAllProcessPagination}
            pagination={{
              current: page,
              position: [ntop, nbottom],
              size: "small",
              defaultPageSize: 10,
              total: pagecount ? pagecount : 0,
              hideOnSinglePage: true,
            }}
            dataSource={dataSource}
            className="clerk-all-process-table"
            bordered
          />
        </div>
      </div>
    </Container>
  );
}